// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OffcanvasMenu-customOffcanvasBackShadow-EBCrJ {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color: #000;
    opacity: 0;
    visibility: hidden;
    -webkit-transition: opacity .3s ease-in-out, visibility .3s ease-in-out;
    transition: opacity .3s ease-in-out, visibility .3s ease-in-out;
}

.OffcanvasMenu-customOffcanvasBackShadow-EBCrJ.OffcanvasMenu-customOffcanvasBackShadowShow-IAbQs {
    opacity: .5;
    visibility: visible;
}

.OffcanvasMenu-customOffcanvas-wEuNN {
    position: fixed;
    bottom: 0;
    z-index: 1050;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    max-width: 100%;
    background: var(--sideMenu-primary);
    background-clip: padding-box;
    outline: 0;
    opacity: 0;
    -webkit-transition: opacity 0.4s linear 0.3s,
        -webkit-transform 0.3s ease-in-out;
    transition: opacity 0.4s linear 0.3s,
        -webkit-transform 0.3s ease-in-out;
    transition: opacity 0.4s linear 0.3s,
        transform 0.3s ease-in-out;
    transition: opacity 0.4s linear 0.3s,
        transform 0.3s ease-in-out,
        -webkit-transform 0.3s ease-in-out;
}

.OffcanvasMenu-customOffcanvasStart-vhPZx {
    top: 0;
    left: 0;
    width: var(--sideMenu-width);
    -webkit-transform: translateX(-100%);
        -ms-transform: translateX(-100%);
            transform: translateX(-100%);
}

.OffcanvasMenu-customOffcanvasEnd-q4ajI {
    top: 0;
    right: 0;
    width: var(--sideMenu-width);
    -webkit-transform: translateX(100%);
        -ms-transform: translateX(100%);
            transform: translateX(100%);
}

.OffcanvasMenu-customOffcanvas-wEuNN.OffcanvasMenu-customOffcanvasShow-VmEq6 {
    -webkit-transform: none;
        -ms-transform: none;
            transform: none;
    opacity: 1;
    -webkit-transition: opacity 0.2s, -webkit-transform 0.3s ease-in-out;
    transition: opacity 0.2s, -webkit-transform 0.3s ease-in-out;
    transition: opacity 0.2s, transform 0.3s ease-in-out;
    transition: opacity 0.2s, transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;
}

.OffcanvasMenu-customOffcanvasBody-V9dA1 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    width: 100%;
    height: 100%;
}

.OffcanvasMenu-customOffcanvasHeader-k1EDZ {
    display: grid;
    -webkit-box-pack: end;
        -ms-flex-pack: end;
            justify-content: flex-end;
    padding: 6px 6px 0;
}

.OffcanvasMenu-customOffcanvasBtnClose-K0Xvg,
.OffcanvasMenu-customOffcanvasBtnClose-K0Xvg:hover,
.OffcanvasMenu-customOffcanvasBtnClose-K0Xvg:focus,
.OffcanvasMenu-customOffcanvasBtnClose-K0Xvg:active:hover,
.OffcanvasMenu-customOffcanvasBtnClose-K0Xvg:active:focus {
    width: 28px;
    height: 28px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    background: transparent;
    padding: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: var(--sideMenu-primary-foreground);
    border: none;
    outline: unset;
    -webkit-box-shadow: unset;
            box-shadow: unset;
}

@media (min-width: 1200px) {
    .OffcanvasMenu-customOffcanvasContainer-DjYYz {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/SideMenu/MobileSideBar/OffcanvasMenu.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,kBAAkB;IAClB,uEAAiE;IAAjE,+DAAiE;AACrE;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,aAAa;IACb,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,eAAe;IACf,mCAAmC;IACnC,4BAA4B;IAC5B,UAAU;IACV,UAAU;IACV;0CAC8B;IAD9B;0CAC8B;IAD9B;kCAC8B;IAD9B;;0CAC8B;AAClC;;AAEA;IACI,MAAM;IACN,OAAO;IACP,4BAA4B;IAC5B,oCAA4B;QAA5B,gCAA4B;YAA5B,4BAA4B;AAChC;;AAEA;IACI,MAAM;IACN,QAAQ;IACR,4BAA4B;IAC5B,mCAA2B;QAA3B,+BAA2B;YAA3B,2BAA2B;AAC/B;;AAEA;IACI,uBAAe;QAAf,mBAAe;YAAf,eAAe;IACf,UAAU;IACV,oEAAoD;IAApD,4DAAoD;IAApD,oDAAoD;IAApD,wFAAoD;AACxD;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qBAAyB;QAAzB,kBAAyB;YAAzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;;;;;IAKI,WAAW;IACX,YAAY;IACZ,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,uBAAuB;IACvB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;IACzC,YAAY;IACZ,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".customOffcanvasBackShadow {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1040;\n    width: 100vw;\n    height: 100vh;\n    background-color: #000;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity .3s ease-in-out, visibility .3s ease-in-out, ;\n}\n\n.customOffcanvasBackShadow.customOffcanvasBackShadowShow {\n    opacity: .5;\n    visibility: visible;\n}\n\n.customOffcanvas {\n    position: fixed;\n    bottom: 0;\n    z-index: 1050;\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    background: var(--sideMenu-primary);\n    background-clip: padding-box;\n    outline: 0;\n    opacity: 0;\n    transition: opacity 0.4s linear 0.3s,\n        transform 0.3s ease-in-out;\n}\n\n.customOffcanvasStart {\n    top: 0;\n    left: 0;\n    width: var(--sideMenu-width);\n    transform: translateX(-100%);\n}\n\n.customOffcanvasEnd {\n    top: 0;\n    right: 0;\n    width: var(--sideMenu-width);\n    transform: translateX(100%);\n}\n\n.customOffcanvas.customOffcanvasShow {\n    transform: none;\n    opacity: 1;\n    transition: opacity 0.2s, transform 0.3s ease-in-out;\n}\n\n.customOffcanvasBody {\n    display: flex;\n    flex-grow: 1;\n    width: 100%;\n    height: 100%;\n}\n\n.customOffcanvasHeader {\n    display: grid;\n    justify-content: flex-end;\n    padding: 6px 6px 0;\n}\n\n.customOffcanvasBtnClose,\n.customOffcanvasBtnClose:hover,\n.customOffcanvasBtnClose:focus,\n.customOffcanvasBtnClose:active:hover,\n.customOffcanvasBtnClose:active:focus {\n    width: 28px;\n    height: 28px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    padding: 0;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    color: var(--sideMenu-primary-foreground);\n    border: none;\n    outline: unset;\n    box-shadow: unset;\n}\n\n@media (min-width: 1200px) {\n    .customOffcanvasContainer {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customOffcanvasBackShadow": `OffcanvasMenu-customOffcanvasBackShadow-EBCrJ`,
	"customOffcanvasBackShadowShow": `OffcanvasMenu-customOffcanvasBackShadowShow-IAbQs`,
	"customOffcanvas": `OffcanvasMenu-customOffcanvas-wEuNN`,
	"customOffcanvasStart": `OffcanvasMenu-customOffcanvasStart-vhPZx`,
	"customOffcanvasEnd": `OffcanvasMenu-customOffcanvasEnd-q4ajI`,
	"customOffcanvasShow": `OffcanvasMenu-customOffcanvasShow-VmEq6`,
	"customOffcanvasBody": `OffcanvasMenu-customOffcanvasBody-V9dA1`,
	"customOffcanvasHeader": `OffcanvasMenu-customOffcanvasHeader-k1EDZ`,
	"customOffcanvasBtnClose": `OffcanvasMenu-customOffcanvasBtnClose-K0Xvg`,
	"customOffcanvasContainer": `OffcanvasMenu-customOffcanvasContainer-DjYYz`
};
module.exports = ___CSS_LOADER_EXPORT___;
